// 提供对应卡种需要的图片资源
import ALIORBANK_PNG from '@/assets/images/BANKTRANSFER_PL/aliorbank.png';
import BANK_NOWY_PNG from '@/assets/images/BANKTRANSFER_PL/Bank Nowy S.A. .png';
import BANK_POCZTOWY_PNG from '@/assets/images/BANKTRANSFER_PL/Bank Pocztowy .png';
import BANKI_SPOLDZIELCZE_PNG from '@/assets/images/BANKTRANSFER_PL/Banki Spółdzielcze.png';
import BNP_PARIBAS_PNG from '@/assets/images/BANKTRANSFER_PL/BNP Paribas .png';
import BOS_BANK_PNG from '@/assets/images/BANKTRANSFER_PL/BOŚ Bank .png';
import CITIBANK_PNG from '@/assets/images/BANKTRANSFER_PL/Citibank.png';
import CREDIT_AGRICOLE_PNG from '@/assets/images/BANKTRANSFER_PL/Credit Agricole .png';
import ING_PNG from '@/assets/images/BANKTRANSFER_PL/ING.png';
import INTELIGO_PNG from '@/assets/images/BANKTRANSFER_PL/Inteligo.png';
import IPKO_PNG from '@/assets/images/BANKTRANSFER_PL/IPKO.png';
import MBANK_PNG from '@/assets/images/BANKTRANSFER_PL/mBank.png';
import MILLENNIUM_PNG from '@/assets/images/BANKTRANSFER_PL/Millennium.png';
import NEST_BANK_PNG from '@/assets/images/BANKTRANSFER_PL/Nest Bank .png';
import PEKAO_PNG from '@/assets/images/BANKTRANSFER_PL/Pekao.png';
import PLUS_BANK_PNG from '@/assets/images/BANKTRANSFER_PL/Plus Bank .png';
import SANTANDER_PNG from '@/assets/images/BANKTRANSFER_PL/Santander Bank Polska.png';
import CASH_7ELEVEN_IMG from '@/assets/images/Cash_MY/1-7eleven-img.png';
import CASH_99SPEEDMART_IMG from '@/assets/images/Cash_MY/99speedmart-img.png';
import CASH_KKMART_IMG from '@/assets/images/Cash_MY/kkmart-img.png';
import DANA_BANK1_PNG from '@/assets/images/dana/bank1.png';
import DANA_BANK2_PNG from '@/assets/images/dana/bank2.png';
import DANA_BANK3_PNG from '@/assets/images/dana/bank3.png';
import DANA_BANK4_PNG from '@/assets/images/dana/bank4.png';
import DANA_BANK5_PNG from '@/assets/images/dana/bank5.png';
import DANA_BANK6_PNG from '@/assets/images/dana/bank6.png';
import DANA_BANK7_PNG from '@/assets/images/dana/bank7.png';
import VIRTUAL_ACCOUNT_BANK_BCA from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BCA.png';
import VIRTUAL_ACCOUNT_BANK_BNC from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BNC.png';
import VIRTUAL_ACCOUNT_BANK_BNI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BNI.png';
import VIRTUAL_ACCOUNT_BANK_BRI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BRI.png';
import VIRTUAL_ACCOUNT_BANK_BSI from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BSI.png';
import VIRTUAL_ACCOUNT_BANK_BSS from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BSS.png';
import VIRTUAL_ACCOUNT_BANK_BTN from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_BTN.png';
import VIRTUAL_ACCOUNT_BANK_CIMB from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_CIMB.png';
import VIRTUAL_ACCOUNT_BANK_Danamon from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_Danamon.png';
import VIRTUAL_ACCOUNT_BANK_Mandiri from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_Mandiri.svg';
import VIRTUAL_ACCOUNT_BANK_Permata from '@/assets/images/doku/VIRTUAL_ACCOUNT_BANK_Permata.png';
import FPX_AFFIN_BANK_PNG from '@/assets/images/FPX/Affin Bank.png';
import FPX_AGROBANK_PNG from '@/assets/images/FPX/Agrobank.png';
import FPX_AMBANK_PNG from '@/assets/images/FPX/AmBank.png';
import FPX_AFFIN_MAX_PNG from '@/assets/images/FPX/Aﬃn Max.png';
import FPX_BANK_ISLAM_PNG from '@/assets/images/FPX/Bank Islam.png';
import FPX_BNP_PARIBAS_PNG from '@/assets/images/FPX/BNP Paribas.png';
import FPX_CIMB_BANK_PNG from '@/assets/images/FPX/CIMB Bank.png';
import FPX_CITIBANK_PNG from '@/assets/images/FPX/Citibank.png';
import FPX_DIRECT_DEBIT_PNG from '@/assets/images/FPX/Direct Debit.png';
import FPX_HONG_LEONG_PNG from '@/assets/images/FPX/Hong Leong.png';
import FPX_HSBC_BANK_PNG from '@/assets/images/FPX/HSBC Bank.png';
import FPX_I_BIZRAKYAT_PNG from '@/assets/images/FPX/i-bizRAKYAT.png';
import FPX_MAYBANK_PNG from '@/assets/images/FPX/Maybank.png';
import FPX_PUBLIC_BANK_ENTERPRISE_PNG from '@/assets/images/FPX/Public Bank Enterprise.png';
import FPX_PUBLIC_BANK_PNG from '@/assets/images/FPX/Public Bank.png';
import FPX_RHB_BANK_PNG from '@/assets/images/FPX/RHB Bank.png';
import FPX_UNITED_OVERSEAS_BANK_PNG from '@/assets/images/FPX/United Overseas Bank.png';
import AFFIN_BANK_IMG from '@/assets/images/Internet_Banking_MY/affin-bank-img.png';
import AGRO_BANK_IMG from '@/assets/images/Internet_Banking_MY/agro-bank-img.png';
import ALLIANCE_BANK_IMG from '@/assets/images/Internet_Banking_MY/alliance-bank-img.png';
import AMBANK_IMG from '@/assets/images/Internet_Banking_MY/ambank-img.png';
import BANK_ISLAM_IMG from '@/assets/images/Internet_Banking_MY/bank-islam-img.png';
import BANK_MUAMALAT_IMG from '@/assets/images/Internet_Banking_MY/bank-muamalat-img.png';
import BANK_OF_CHINA_IMG from '@/assets/images/Internet_Banking_MY/bank-of-china-img.png';
import BANK_RAKYAT_IMG from '@/assets/images/Internet_Banking_MY/bank-rakyat-img.png';
import BSN_IMG from '@/assets/images/Internet_Banking_MY/bsn-img.png';
import CIMB_BANK_IMG from '@/assets/images/Internet_Banking_MY/cimb-bank-img.png';
import HONG_LEONG_BANK_IMG from '@/assets/images/Internet_Banking_MY/hong-leong-bank-img.png';
import HSBC_IMG from '@/assets/images/Internet_Banking_MY/hsbc-img.png';
import KUWAIT_FINANCE_HOUSE_IMG from '@/assets/images/Internet_Banking_MY/kuwait-finance-house-img.png';
import MAYBANK_IMG from '@/assets/images/Internet_Banking_MY/maybank-img.png';
import OCBC_BANK_IMG from '@/assets/images/Internet_Banking_MY/ocbc-bank-img.png';
import PUBLIC_BANK_IMG from '@/assets/images/Internet_Banking_MY/public-bank-img.png';
import RHB_BANK_IMG from '@/assets/images/Internet_Banking_MY/rhb-bank-img.png';
import STANDARD_CHARTERED_IMG from '@/assets/images/Internet_Banking_MY/standard-chartered-img.png';
import UOB_IMG from '@/assets/images/Internet_Banking_MY/uob-img.png';
import MOBILE_BANKING_BAY_PNG from '@/assets/images/MOBILE_BANKING/mobile_banking_bay.png';
import MOBILE_BANKING_BBL_PNG from '@/assets/images/MOBILE_BANKING/mobile_banking_bbl.png';
import MOBILE_BANKING_KBANK_PNG from '@/assets/images/MOBILE_BANKING/mobile_banking_kbank.png';
import MOBILE_BANKING_KTB_PNG from '@/assets/images/MOBILE_BANKING/mobile_banking_ktb.png';
import MOBILE_BANKING_SCB_PNG from '@/assets/images/MOBILE_BANKING/mobile_banking_scb.png';

export const CASH_MY_OPTIONS = [
  { code: 'CASH-711', name: '7-Eleven', image: CASH_7ELEVEN_IMG },
  { code: 'CASH-99', name: '99 Speedmart', image: CASH_99SPEEDMART_IMG },
  { code: 'CASH-KK', name: 'KK Mart', image: CASH_KKMART_IMG },
];

export const DANA_BANK_OPTIONS = [
  { code: 'VIRTUAL_ACCOUNT_BCA', image: DANA_BANK1_PNG },
  { code: 'VIRTUAL_ACCOUNT_BNI', image: DANA_BANK2_PNG },
  { code: 'VIRTUAL_ACCOUNT_BRI', image: DANA_BANK3_PNG },
  { code: 'VIRTUAL_ACCOUNT_BTPN', image: DANA_BANK4_PNG },
  { code: 'VIRTUAL_ACCOUNT_CIMB', image: DANA_BANK5_PNG },
  { code: 'VIRTUAL_ACCOUNT_MANDIRI', image: DANA_BANK6_PNG },
  { code: 'VIRTUAL_ACCOUNT_PERMATA', image: DANA_BANK7_PNG },
];

export const DOKU_BANK_OPTIONS = [
  { code: 'VIRTUAL_ACCOUNT_BANK_CIMB', image: VIRTUAL_ACCOUNT_BANK_CIMB },
  { code: 'VIRTUAL_ACCOUNT_BANK_BSI', image: VIRTUAL_ACCOUNT_BANK_BSI },
  { code: 'VIRTUAL_ACCOUNT_BANK_BCA', image: VIRTUAL_ACCOUNT_BANK_BCA },
  { code: 'VIRTUAL_ACCOUNT_BANK_BNC', image: VIRTUAL_ACCOUNT_BANK_BNC },
  { code: 'VIRTUAL_ACCOUNT_BANK_BNI', image: VIRTUAL_ACCOUNT_BANK_BNI },
  { code: 'VIRTUAL_ACCOUNT_BANK_Mandiri', image: VIRTUAL_ACCOUNT_BANK_Mandiri },
  { code: 'VIRTUAL_ACCOUNT_BANK_BRI', image: VIRTUAL_ACCOUNT_BANK_BRI },

  { code: 'VIRTUAL_ACCOUNT_BANK_BTN', image: VIRTUAL_ACCOUNT_BANK_BTN },
  { code: 'VIRTUAL_ACCOUNT_BANK_Permata', image: VIRTUAL_ACCOUNT_BANK_Permata },
  { code: 'VIRTUAL_ACCOUNT_BANK_Danamon', image: VIRTUAL_ACCOUNT_BANK_Danamon },
  { code: 'VIRTUAL_ACCOUNT_BANK_BSS', image: VIRTUAL_ACCOUNT_BANK_BSS },
];

export const INTERNET_BANKING_MY_OPTIONS = [
  { code: 'RPP_RTP_ABB', name: 'Affin Bank', image: AFFIN_BANK_IMG },
  { code: 'RPP_RTP_ABMB', name: 'Alliance Bank', image: ALLIANCE_BANK_IMG },
  { code: 'RPP_RTP_AGROBANK', name: 'Agrobank', image: AGRO_BANK_IMG },
  { code: 'RPP_RTP_AMB', name: 'AmBank', image: AMBANK_IMG },
  { code: 'RPP_RTP_CIMBC_LICKS', name: 'CIMB Bank', image: CIMB_BANK_IMG },
  { code: 'RPP_RTP_BIMB', name: 'Bank Islam', image: BANK_ISLAM_IMG },
  { code: 'RPP_RTP_BKRM', name: 'Bank Rakyat', image: BANK_RAKYAT_IMG },
  { code: 'RPP_RTP_BMMB', name: 'Bank Muamalat', image: BANK_MUAMALAT_IMG },
  { code: 'RPP_RTP_BSN', name: 'Bank Simpanan Nasional (BSN)', image: BSN_IMG },
  { code: 'RPP_RTP_HLB', name: 'Hong Leong', image: HONG_LEONG_BANK_IMG },
  { code: 'RPP_RTP_HSBC', name: 'HSBC Bank', image: HSBC_IMG },
  { code: 'RPP_RTP_KFH', name: 'Kuwait Finance House', image: KUWAIT_FINANCE_HOUSE_IMG },
  { code: 'RPP_RTP_MB2U', name: 'Maybank', image: MAYBANK_IMG },
  { code: 'RPP_RTP_OCBC', name: 'OCBC', image: OCBC_BANK_IMG },
  { code: 'RPP_RTP_PBB', name: 'Public Bank', image: PUBLIC_BANK_IMG },
  { code: 'RPP_RTP_RHB', name: 'RHB Bank', image: RHB_BANK_IMG },
  { code: 'RPP_RTP_SCB', name: 'Standard Chartered', image: STANDARD_CHARTERED_IMG },
  { code: 'RPP_RTP_UOB', name: 'United Overseas Bank', image: UOB_IMG },
  { code: 'RPP_RTP_BOCM', name: 'Bank Of China', image: BANK_OF_CHINA_IMG },
];

export const BANKTRANSFER_PL_OPTIONS = [
  { code: 'ab', name: 'Płacę z Alior Bankiem', image: ALIORBANK_PNG },
  { code: 'bn', name: 'Bank Nowy S.A.', image: BANK_NOWY_PNG },
  { code: 'wys', name: 'Bank Pocztowy', image: BANK_POCZTOWY_PNG },
  { code: 'bs', name: 'Banki Spółdzielcze', image: BANKI_SPOLDZIELCZE_PNG },
  { code: 'bnx', name: 'BNP Paribas', image: BNP_PARIBAS_PNG },
  { code: 'bo', name: 'Płać z BOŚ', image: BOS_BANK_PNG },
  { code: 'wc', name: 'Przelew z Citi Handlowego', image: CITIBANK_PNG },
  { code: 'l', name: 'Credit Agricole', image: CREDIT_AGRICOLE_PNG },
  { code: 'g', name: 'Płać z ING', image: ING_PNG },
  { code: 'i', name: 'Płacę z Inteligo', image: INTELIGO_PNG },
  { code: 'p', name: 'Płać z iPKO', image: IPKO_PNG },
  { code: 'm', name: 'mTransfer - mBank', image: MBANK_PNG },
  { code: 'wm', name: 'Przelew z Millennium', image: MILLENNIUM_PNG },
  { code: 'nstb', name: 'Nest bank', image: NEST_BANK_PNG },
  { code: 'o', name: 'Pekao24Przelew - Bank Pekao', image: PEKAO_PNG },
  { code: 'plsb', name: 'Plus Bank', image: PLUS_BANK_PNG },
  { code: 'w', name: 'Przelew24 - Santander (form. BZ WBK)', image: SANTANDER_PNG },
];

export const FPX_OPTIONS = [
  { code: 'FPX_B2B_ABB', name: 'Affin Bank', image: FPX_AFFIN_BANK_PNG },
  { code: 'FPX_B2B_ABBM', name: 'Affin Max', image: FPX_AFFIN_MAX_PNG },
  { code: 'FPX_B2B_AGROBANK', name: 'Agrobank', image: FPX_AGROBANK_PNG },
  { code: 'FPX_B2B_AMB', name: 'AmBank', image: FPX_AMBANK_PNG },
  { code: 'FPX_B2B_CIMB', name: 'CIMB Bank', image: FPX_CIMB_BANK_PNG },
  { code: 'FPX_B2B_BIMB', name: 'Bank Islam', image: FPX_BANK_ISLAM_PNG },
  { code: 'FPX_B2B_HLB', name: 'Hong Leong', image: FPX_HONG_LEONG_PNG },
  { code: 'FPX_B2B_HSBC', name: 'HSBC Bank', image: FPX_HSBC_BANK_PNG },
  { code: 'FPX_M2E', name: 'Maybank', image: FPX_MAYBANK_PNG },
  { code: 'FPX_B2B_PBB', name: 'Public Bank', image: FPX_PUBLIC_BANK_PNG },
  { code: 'FPX_B2B_PBBE', name: 'Public Bank Enterprise', image: FPX_PUBLIC_BANK_ENTERPRISE_PNG },
  { code: 'FPX_B2B_RHB', name: 'RHB Bank', image: FPX_RHB_BANK_PNG },
  { code: 'FPX_B2B_UOB', name: 'United Overseas Bank', image: FPX_UNITED_OVERSEAS_BANK_PNG },
  { code: 'FPX_B2B_UOBR', name: 'United Overseas Bank Regional', image: FPX_UNITED_OVERSEAS_BANK_PNG },
  { code: 'FPX_B2B_BNP', name: 'BNP Paribas', image: FPX_BNP_PARIBAS_PNG },
  { code: 'FPX_B2B_CITIBANK', name: 'Citibank', image: FPX_CITIBANK_PNG },
  { code: 'FPX_B2B_BKRM', name: 'i-bizRAKYAT', image: FPX_I_BIZRAKYAT_PNG },
  { code: 'FPX_EMANDATE', name: 'DirectDebit e-Mandate B2C', image: FPX_DIRECT_DEBIT_PNG },
  { code: 'FPX_EMANDATE_ABB', name: 'DirectDebit e-Mandate', image: FPX_DIRECT_DEBIT_PNG },
];

export const MOBILE_BANKING_OPTIONS = [
  { code: 'mobile_banking_bay', name: 'Bank of Ayudhya (BAY)', image: MOBILE_BANKING_BAY_PNG },
  { code: 'mobile_banking_bbl', name: 'Bangkok Bank (BBL)', image: MOBILE_BANKING_BBL_PNG },
  { code: 'mobile_banking_kbank', name: 'Kasikorn Bank (KBANK)', image: MOBILE_BANKING_KBANK_PNG },
  { code: 'mobile_banking_ktb', name: 'Krung Thai Bank (KTB)', image: MOBILE_BANKING_KTB_PNG },
  { code: 'mobile_banking_scb', name: 'Siam Commercial Bank (SCB)', image: MOBILE_BANKING_SCB_PNG },
];
